import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a95908b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home-echarts-header",
  style: {"padding":"10px 24px 0 24px","height":"auto"}
}
const _hoisted_2 = { class: "home-echarts-header__title" }
const _hoisted_3 = { class: "home-echarts-header__controls" }

import type { PropType, Ref } from 'vue'
import { onBeforeMount, reactive, ref, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import dayjs, { Dayjs } from 'dayjs'
import { getAlarmTrend } from '@/api/gucangSales/regionDataBoard'
import { alarmTypeEnum } from '@/views/gucangSales/commonEnum/dataConfig'


const __default__ = { name: 'CustomerAlarmTrend' }

interface QueryFormType {
  customerRegionEmployeeNoList?: string[]
  startDay?: string
  endDay?: string
  // 1/2,按频次/按客户数】
  frequencyOrCustomersQuery: number,
  // 异动类型
  alarmType: number
}
interface ItemCommonType {
  name: string
  quantity: number,
  total: number,
  prop: string,
  monthValue?:number,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    default: '每月触发异动趋势'
  },
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '350px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '8px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  customerRegionEmployeeNoList: {
    type: Array as PropType<string[]>,
    default: () => []
  }
},
  setup(__props) {

const yearValue = ref<Dayjs>(dayjs())
const props = __props

const spinning = ref(false)
const showECharts = ref(false)
const startMonth = ref<string>(dayjs(yearValue.value).startOf('month').format('YYYY01'))
const endMonth = ref<string>(dayjs(yearValue.value).endOf('month').format('YYYY12'))
const xAxisData = ref<any[]>([])
const queryForm = reactive<QueryFormType>({
  startDay: dayjs(yearValue.value).startOf('year').format('YYYY/MM/DD'),
  endDay: dayjs(yearValue.value).endOf('year').format('YYYY/MM/DD'),
  customerRegionEmployeeNoList: props.customerRegionEmployeeNoList,
  frequencyOrCustomersQuery: 1,
  alarmType: 2
})
watch(() => props.customerRegionEmployeeNoList, (val) => {
  queryForm.customerRegionEmployeeNoList = val
  getData()
})
const handleDateChange = () => {
  queryForm.startDay = dayjs(yearValue.value).startOf('year').format('YYYY/MM/DD')
  queryForm.endDay = dayjs(yearValue.value).endOf('year').format('YYYY/MM/DD')
  startMonth.value = dayjs(yearValue.value).startOf('month').format('YYYY01')
  endMonth.value = dayjs(yearValue.value).endOf('month').format('YYYY12')
  xAxisData.value = generateTimeArray(startMonth.value, endMonth.value, 'YYYYmm')
  getData()
}
function generateTimeArray(startTime: string, endTime: string, format: 'YYYYmm'|'YYYYww'|'YYYY/MM/DD') {
  const start = dayjs(startTime, format)
  const end = dayjs(endTime, format)
  const result = []

  let current = start

  if (format === 'YYYYmm') {
    while (current.isBefore(end) || current.isSame(end)) {
      result.push({ value: current.format(format), name: current.format('m') + '月' })
      current = current.add(1, 'm')
    }
  } else if (format === 'YYYY/MM/DD') {
    while (current.isBefore(end) || current.isSame(end)) {
      result.push({ value: current.format(format), name: current.format('D') })
      current = current.add(1, 'day')
    }
  } else {
    throw new Error('Unsupported format')
  }
  return result
}
const getData = () => {
  spinning.value = true
  getAlarmTrend(queryForm)
    .then((res) => {
      const alarmLevel1List = res.data?.alarmLevel1List as unknown as ItemCommonType[]
      const alarmLevel2List = res.data?.alarmLevel2List as unknown as ItemCommonType[]
      const alarmLevel3List = res.data?.alarmLevel3List as unknown as ItemCommonType[]
      const theChartAlarmLevel1List = transChartData(alarmLevel1List)
      const theChartAlarmLevel2List = transChartData(alarmLevel2List)
      const theChartAlarmLevel3List = transChartData(alarmLevel3List)
      if ((theChartAlarmLevel1List.length === 0) &&
        (theChartAlarmLevel2List.length === 0) &&
        (theChartAlarmLevel3List.length === 0)) {
        showECharts.value = false
        initChart([], [], [])
      } else {
        showECharts.value = true
        initChart(theChartAlarmLevel1List, theChartAlarmLevel2List, theChartAlarmLevel3List)
      }
    })
    .finally(() => {
      spinning.value = false
    })
}
/// 格式化接口数据和日期对应
const transChartData = (serviceData: ItemCommonType[]) => {
  const matchData: number[] = []
  if (serviceData && serviceData.length > 0) {
    xAxisData.value.forEach((axis) => {
      const matchItem = serviceData.find((item) => {
        return (item.monthValue ?? 0).toString() === axis.value
      })
      if (matchItem) {
        matchData.push(matchItem.quantity ?? 0)
      } else {
        matchData.push(0)
      }
    })
  }
  return matchData
}
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)
const initChart = (theChartAlarmLevel1List: number[],
  theChartAlarmLevel2List: number[],
  theChartAlarmLevel3List: number[]) => {
  setOptions({
    // 悬浮窗
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#1D4CD2',
      textStyle: {
        color: 'White'
      },
      formatter: function (params) {
        const currentData = xAxisData.value[params[0].dataIndex].value
        const toolsTipsResult = []
        toolsTipsResult.push(currentData)
        for (let i = 0; i < params.length; i++) {
          const currentParam = params[i]
          toolsTipsResult.push(currentParam.seriesName + '  <strong>' + currentParam.value + '</strong>')
        }
        return toolsTipsResult.join('<br>')
      }
    },
    /// 在这里配置线条颜色和legend颜色一致
    color: ['#FF9A3E', '#1CA550', '#1D4CD2'],
    legend: {
      itemWidth: 12,
      itemHeight: 2,
      left: 'right',
      icon: 'react',
      right: '50%',
      data: ['一级', '二级', '三级']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xAxisData.value.map((item) => item.name)
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: true,
        lineStyle: {
          color: '#D8DFE4',
          type: 'dashed'
        }
      }
    },
    series: [
      {
        name: '一级',
        type: 'line',
        smooth: true,
        data: theChartAlarmLevel1List,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              // 渐变颜色
              {
                offset: 0,
                color: 'rgb(255,154,62,0.5)'
              },
              {
                offset: 1,
                color: 'rgb(255,154,62,0.0)'
              }
            ],
            global: false
          }
        }
      },
      {
        name: '二级',
        type: 'line',
        smooth: true,
        data: theChartAlarmLevel2List,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              // 渐变颜色
              {
                offset: 0,
                color: 'rgb(56, 161, 105,0.5)'
              },
              {
                offset: 1,
                color: 'rgb(56, 161, 105,0.0)'
              }
            ],
            global: false
          }
        }
      },
      {
        name: '三级',
        type: 'line',
        smooth: true,
        data: theChartAlarmLevel3List,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              // 渐变颜色
              {
                offset: 0,
                color: 'rgb(29, 76, 210,0.5)'
              },
              {
                offset: 1,
                color: 'rgb(29, 76, 210,0.0)'
              }
            ],
            global: false
          }
        }
      }
    ]
  })
}
onBeforeMount(() => {
  if (!queryForm.startDay) {
    queryForm.startDay = dayjs(yearValue.value).startOf('year').format('YYYY/MM/DD')
  }
  if (!queryForm.endDay) {
    queryForm.endDay = dayjs(yearValue.value).endOf('year').format('YYYY/MM/DD')
  }
  xAxisData.value = generateTimeArray(startMonth.value, endMonth.value, 'YYYYmm')
  getData()
})

return (_ctx: any,_cache: any) => {
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height, marginBottom: __props.marginBottom })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CosSelect, {
          value: queryForm.alarmType,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.alarmType) = $event)),
          allowClear: props.allowClear,
          style: {"width":"125px","margin-left":"10px"},
          onChange: getData,
          options: _unref(alarmTypeEnum)
        }, null, 8, ["value", "allowClear", "options"]),
        _createVNode(_component_a_date_picker, {
          onChange: handleDateChange,
          value: yearValue.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((yearValue).value = $event)),
          allowClear: false,
          style: {"width":"125px"},
          picker: "year"
        }, null, 8, ["value"]),
        _createVNode(_component_a_radio_group, {
          value: queryForm.frequencyOrCustomersQuery,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.frequencyOrCustomersQuery) = $event)),
          style: {"margin-left":"10px","display":"inline-block"},
          onChange: handleDateChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_button, {
              value: 1,
              class: "radio-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 频次 ")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, {
              value: 2,
              class: "radio-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 客户数 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createVNode(_component_a_spin, {
      spinning: spinning.value,
      delay: 200
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "home-echarts-content"
        }, null, 512), [
          [_vShow, showECharts.value]
        ]),
        (!showECharts.value)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 4))
}
}

})